import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function table(theme): ComponentStyle {
  return {
    componentName: 'table',
    baseStyle: {
      border: 'none',
      borderRadius: 'unset',
      borderBottom: `1px solid ${theme.colors.border15}`
    }
  };
}
